import {
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
  Table,
  Badge,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import LoyaltyTab from "./LoyaltyModern";
import InfluencerTab from "./InfluencerTab";

const DISPLAY_CURRENCY = "COP";

export const UserBonusModal = ({ isOpen, toggle, user }) => {
  const [activeTab, setActiveTab] = useState("loyalty");

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" scrollable>
      
      <ModalHeader toggle={toggle}>
        Bonos del Usuario
      </ModalHeader>

      <ModalBody>
        <Nav tabs className="mb-3">
          <NavItem>
            <NavLink
              className={activeTab === "loyalty" ? "active" : ""}
              onClick={() => setActiveTab("loyalty")}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-crown me-1" /> Regalías
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "influencer" ? "active" : ""}
              onClick={() => setActiveTab("influencer")}
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-bullhorn me-1" /> Bono Influencer
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="loyalty">
            {activeTab === "loyalty" && <LoyaltyTab user={user} />}
          </TabPane>
          <TabPane tabId="influencer">
            {activeTab === "influencer" && <InfluencerTab user={user} />}
          </TabPane>
        </TabContent>
      </ModalBody>
    </Modal>
  );
};